import React from 'react';
import { connect } from 'react-redux';
import { compareByNumericProp } from '../../utils/comparators';
import Selector from '../util/Selector';

import './multi-select.css';

const SELECT_ALL = 'select-all';

const BuildingMultiSelector = ({
  selected,
  buildings,
  onValueChange,
  allText = 'All Sites',
  noneText = 'All Sites',
  disabled = false,
}) => (
  <Selector
    className="building-multi-select"
    multiple
    disabled={disabled}
    options={[{ key: SELECT_ALL, id: SELECT_ALL, display: 'Select All' }].concat(
      buildings.map(({ id, name }) => ({
        id,
        key: id,
        display: name,
      }))
    )}
    selected={selected}
    onChange={(e) => {
      if (e.target.value?.indexOf(SELECT_ALL) !== -1) {
        onValueChange(buildings.map(({ id }) => id));
      } else {
        onValueChange(e.target.value);
      }
    }}
    displayEmpty
    renderValue={(sites) => {
      const len = sites?.length;
      if (len === 0) return noneText;
      if (len === buildings.length) return allText;
      return len === 1 ? '1 Site' : `${len} Sites`;
    }}
  />
);

export default connect(
  (
    {
      entities: {
        buildings: { byId },
      },
    },
    { orgId: filterOrgId }
  ) => {
    const buildings = Object.values(byId).filter(
      ({ orgId }) => filterOrgId == null || filterOrgId === orgId
    );
    buildings.sort(compareByNumericProp('name'));
    return { buildings };
  }
)(BuildingMultiSelector);
